import React, { useState } from 'react';
import { ProjectFilterPills } from '../components/ProjectFilterPills';
import { useProjectFilter, AVAILABLE_PROJECTS } from '../contexts/ProjectFilterContext';
import { ArrowLeft, Search, SlidersHorizontal, FileText, CheckCircle2, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
interface InspectionRecord {
  id: string;
  siteName: string;
  checklistName: string;
  date: string;
  status: 'Done' | 'In Progress';
  reporter: string;
}
const MOCK_RECORDS: InspectionRecord[] = [{
  id: '1',
  siteName: '251 Douglass Street, Block 412 Lot 50',
  checklistName: 'Scaffold & Sidewalk Shed Daily Inspections',
  date: '01/15/2026',
  status: 'Done',
  reporter: 'M. Elizabeth Lagana'
}, {
  id: '2',
  siteName: '251 Douglass Street, Block 412 Lot 50',
  checklistName: 'Construction Site Fire Safety Manager (CSFSM) Daily Report',
  date: '01/15/2026',
  status: 'Done',
  reporter: 'M. Elizabeth Lagana'
}, {
  id: '3',
  siteName: '251 Douglass Street, Block 412 Lot 50',
  checklistName: 'STANDPIPE DAILY INSPECTION',
  date: '01/15/2026',
  status: 'Done',
  reporter: 'M. Elizabeth Lagana'
}, {
  id: '4',
  siteName: 'Court Square LIC',
  checklistName: 'SITE SAFETY DAILY LOG',
  date: '01/15/2026',
  status: 'In Progress',
  reporter: 'Martin Gilrane'
}, {
  id: '5',
  siteName: '251 Douglass Street, Block 412 Lot 50',
  checklistName: 'Scaffold & Sidewalk Shed Daily Inspections',
  date: '01/12/2026',
  status: 'Done',
  reporter: 'M. Elizabeth Lagana'
}, {
  id: '6',
  siteName: '251 Douglass Street, Block 412 Lot 50',
  checklistName: 'Construction Site Fire Safety Manager (CSFSM) Daily Report',
  date: '01/12/2026',
  status: 'Done',
  reporter: 'M. Elizabeth Lagana'
}, {
  id: '7',
  siteName: '251 Douglass Street, Block 412 Lot 50',
  checklistName: 'STANDPIPE DAILY INSPECTION',
  date: '01/12/2026',
  status: 'Done',
  reporter: 'M. Elizabeth Lagana'
}, {
  id: '8',
  siteName: 'Court Square LIC',
  checklistName: 'SITE SAFETY DAILY LOG',
  date: '01/12/2026',
  status: 'In Progress',
  reporter: 'Martin Gilrane'
}, {
  id: '9',
  siteName: '251 Douglass Street, Block 412 Lot 50',
  checklistName: 'Scaffold & Sidewalk Shed Daily Inspections',
  date: '01/10/2026',
  status: 'Done',
  reporter: 'M. Elizabeth Lagana'
}, {
  id: '10',
  siteName: '251 Douglass Street, Block 412 Lot 50',
  checklistName: 'Scaffold & Sidewalk Shed Daily Inspections',
  date: '01/10/2026',
  status: 'Done',
  reporter: 'M. Elizabeth Lagana'
}, {
  id: '11',
  siteName: '251 Douglass Street, Block 412 Lot 50',
  checklistName: 'Construction Site Fire Safety Manager (CSFSM) Daily Report',
  date: '01/10/2026',
  status: 'Done',
  reporter: 'M. Elizabeth Lagana'
}, {
  id: '12',
  siteName: '99 Claremont Ave',
  checklistName: 'Weekly Fire Extinguisher Inspection',
  date: '01/08/2026',
  status: 'Done',
  reporter: 'Sarah Mitchell'
}, {
  id: '13',
  siteName: 'Court Square LIC',
  checklistName: 'Weekly Electrical Systems Check',
  date: '01/08/2026',
  status: 'In Progress',
  reporter: 'James Rodriguez'
}, {
  id: '14',
  siteName: '251 Douglass Street, Block 412 Lot 50',
  checklistName: 'Monthly OSHA Compliance Check',
  date: '01/05/2026',
  status: 'Done',
  reporter: 'M. Elizabeth Lagana'
}, {
  id: '15',
  siteName: '450 Park Avenue South',
  checklistName: 'Daily Fall Protection Check',
  date: '01/15/2026',
  status: 'Done',
  reporter: 'David Chen'
}];
type StatusFilter = 'all' | 'Done' | 'In Progress';
export function InspectionsPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [statusFilter, setStatusFilter] = useState<StatusFilter>('all');
  const {
    selectedProjects
  } = useProjectFilter();
  const doneCount = MOCK_RECORDS.filter(r => r.status === 'Done').length;
  const inProgressCount = MOCK_RECORDS.filter(r => r.status === 'In Progress').length;
  const getProjectDisplayText = () => {
    if (selectedProjects.length === AVAILABLE_PROJECTS.length) {
      return 'All Projects';
    }
    if (selectedProjects.length === 1) {
      return selectedProjects[0];
    }
    return `${selectedProjects.length} Projects`;
  };
  const filteredRecords = MOCK_RECORDS.filter(record => {
    // Status filter
    if (statusFilter !== 'all' && record.status !== statusFilter) {
      return false;
    }
    // Search filter
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    return record.siteName.toLowerCase().includes(query) || record.checklistName.toLowerCase().includes(query) || record.reporter.toLowerCase().includes(query);
  });
  return <div className="min-h-screen bg-[#fafafa] font-sans" data-id="element-4212" data-mp="1ydqroefq7w26">
      <main className="p-6 max-w-[1600px] mx-auto pb-24" data-id="element-4213" data-mp="1yd770pyoytkg">
        {/* Header */}
        <div className="mb-6" data-id="element-4214" data-mp="23bs78pdy1d8w">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4 transition-colors" data-id="element-4215" data-mp="23ewnil4onzfx">
            <ArrowLeft size={16} data-id="element-4216" data-mp="2d9okbmqfyi9n" />
            Back to Dashboard
          </Link>
          <div className="flex items-center gap-2" data-id="element-4217" data-mp="1fo0n4zm5vvx2">
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-4218" data-mp="1fl4r5gtvjhb9">
              Inspections & Logs
            </h1>
            <span className="text-gray-400 text-2xl" data-id="element-4219" data-mp="1plf36y46aiou">·</span>
            <span className="text-gray-600 text-xl" data-id="element-4220" data-mp="1pju919lrt1ri">
              {getProjectDisplayText()}
            </span>
          </div>
          <ProjectFilterPills data-id="element-4221" data-mp="1udygdtyy7bt4" />
        </div>

        {/* Mini Dashboard - Status Cards */}
        <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-4222" data-mp="wunc2f1ysk8d">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => setStatusFilter(statusFilter === 'Done' ? 'all' : 'Done')} className={`bg-white rounded-lg border-2 p-6 text-left transition-all ${statusFilter === 'Done' ? 'border-emerald-500 shadow-md' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-4223" data-mp="11v1bx9tewnvb">
            <div className="flex items-center justify-between mb-2" data-id="element-4224" data-mp="aw0tr4njndvp">
              <div className="p-2 bg-emerald-100 rounded-lg" data-id="element-4225" data-mp="ayd9db5txc5l">
                <CheckCircle2 size={24} className="text-emerald-600" data-id="element-4226" data-mp="5y91uamwfrri" />
              </div>
              <div className="text-4xl font-bold text-emerald-600" data-id="element-4227" data-mp="kuqb8wbj2wbf">
                {doneCount}
              </div>
            </div>
            <div className="text-sm font-semibold text-gray-900" data-id="element-4228" data-mp="fu2b9l5bn552">Done</div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-4229" data-mp="1w8kg0h4wahbu">This week</div>
          </motion.button>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => setStatusFilter(statusFilter === 'In Progress' ? 'all' : 'In Progress')} className={`bg-white rounded-lg border-2 p-6 text-left transition-all ${statusFilter === 'In Progress' ? 'border-amber-500 shadow-md' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-4230" data-mp="1r9h9es99o31r">
            <div className="flex items-center justify-between mb-2" data-id="element-4231" data-mp="2hl2qzov3xx8v">
              <div className="p-2 bg-amber-100 rounded-lg" data-id="element-4232" data-mp="2mikswvapjc7d">
                <Clock size={24} className="text-amber-600" data-id="element-4233" data-mp="28s7m4w9jy3jm" />
              </div>
              <div className="text-4xl font-bold text-amber-600" data-id="element-4234" data-mp="28q4w4c8egaew">
                {inProgressCount}
              </div>
            </div>
            <div className="text-sm font-semibold text-gray-900" data-id="element-4235" data-mp="30ivlq3vkv0v6">
              In Progress
            </div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-4236" data-mp="35adlwpps0xf3">This week</div>
          </motion.button>
        </div>

        {/* Results count and controls */}
        <div className="flex items-center justify-between mb-6" data-id="element-4237" data-mp="2glkfkuj8igxw">
          <div className="text-lg font-medium text-gray-900" data-id="element-4238" data-mp="2brzf8vu65avj">
            {filteredRecords.length} results
            {statusFilter !== 'all' && <span className="text-gray-500 ml-2" data-id="element-4239" data-mp="21ulc1xx9ail6">
                · Filtered by {statusFilter}
              </span>}
          </div>

          <div className="flex items-center gap-3" data-id="element-4240" data-mp="2zh0sqxhuzc7o">
            {/* Search */}
            <div className="relative" data-id="element-4241" data-mp="2uiza2dochewq">
              <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-4242" data-mp="2uk0ieadz7nar" />
              <input type="text" placeholder="Search" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent w-64" data-id="element-4243" data-mp="2klku0f6c2s4y" />
            </div>

            {/* Filters button */}
            <button onClick={() => setShowFilters(!showFilters)} className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-4244" data-mp="3ptdu87nxpfp8">
              <SlidersHorizontal size={16} data-id="element-4245" data-mp="8bupswyxjnf5" />
              Filters
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-4246" data-mp="cceow632d13x">
          <table className="w-full" data-id="element-4247" data-mp="hc9c9znmr8k8">
            <thead data-id="element-4248" data-mp="hdc2e5d4p6z3">
              <tr className="border-b border-gray-200 bg-gray-50" data-id="element-4249" data-mp="hapxyeljb7l3">
                <th className="text-left px-6 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-4250" data-mp="mb3uazdrwt3a">
                  PDF
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-4251" data-mp="2o2gwvhs9qow6">
                  Site Name
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-4252" data-mp="toymrs3fxeuf">
                  Checklist Name
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-4253" data-mp="13k8osftu9m87">
                  Date
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-4254" data-mp="1clzql9l9d8ws">
                  Status
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-4255" data-mp="1hiylvvgnrlwk">
                  Reporter
                </th>
              </tr>
            </thead>
            <tbody data-id="element-4256" data-mp="1r9t5st6fm9eu">
              {filteredRecords.map((record, index) => <tr key={record.id} className={`border-b border-gray-100 hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/30'}`} data-id="element-4257" data-mp="1vdis1bzmwewp" data-mpi={index}>
                  <td className="px-6 py-4" data-id="element-4258" data-mp="3kumr13nw281q">
                    <button className="flex items-center justify-center w-10 h-10 bg-red-500 hover:bg-red-600 rounded transition-colors" data-id="element-4259" data-mp="3fui7f4roox7a">
                      <FileText size={18} className="text-white" data-id="element-4260" data-mp="3btg86nxrol5b" />
                    </button>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900" data-id="element-4261" data-mp="36vemrwcvc9qo">
                    {record.siteName}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900" data-id="element-4262" data-mp="3ctqdnn8xcdi">
                    {record.checklistName}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900" data-id="element-4263" data-mp="3uqpuqdye2eqs">
                    {record.date}
                  </td>
                  <td className="px-6 py-4" data-id="element-4264" data-mp="3prwon6lflq0n">
                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${record.status === 'Done' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-4265" data-mp="r25yek6u7ee8">
                      {record.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900" data-id="element-4266" data-mp="1a5zpaao39s4v">
                    {record.reporter}
                  </td>
                </tr>)}
            </tbody>
          </table>

          {filteredRecords.length === 0 && <div className="text-center py-12" data-id="element-4267" data-mp="10evbvfe2afc5">
              <FileText size={48} className="mx-auto text-gray-300 mb-3" data-id="element-4268" data-mp="mgf37iwn2erd" />
              <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-4269" data-mp="rh2t2194spk0">
                No inspections found
              </h3>
              <p className="text-gray-600" data-id="element-4270" data-mp="di3h9u6pw559">
                Try adjusting your search or filters to find what you're looking
                for
              </p>
            </div>}
        </div>
      </main>
    </div>;
}